import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const FinancialIndicatorItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/financialIndicators/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow key={data.id} hover>
      <TableCell>{data.orderNo}</TableCell>
      <TableCell>{data.code}</TableCell>
      <TableCell>{data.name}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton color='primary' size='small' variant='text' type='edit' tooltip={t('Edit')} onClick={handleEdit} />
          <IconButton color='primary' size='small' variant='text' type='delete' tooltip={t('Delete')} onClick={() => onDelete(data.id)} />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

FinancialIndicatorItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default FinancialIndicatorItem;
